export default function findBet(bets, raceId, ticketId) {
  var forRace = bets.get(raceId);
  if (forRace === undefined) {
    return undefined;
  }
  var race = forRace.valueSeq().find((bet) => bet.get("ticket_id") === ticketId);
  if (race === undefined) {
    return undefined;
  }
  return race;
}
